"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*eslint-disable react/display-name */
const framer_motion_1 = require("framer-motion");
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const xstate_1 = require("xstate");
const history_routing_1 = require("../../hooks/history-routing");
const useThrottledResizeObserver_1 = __importDefault(require("../../hooks/useThrottledResizeObserver"));
const Filters_1 = require("../../lib/constants/Filters");
const States_1 = require("../../lib/constants/States");
const steps_1 = __importDefault(require("../../lib/constants/steps"));
const thirdPartyLogin_1 = require("../../lib/constants/thirdPartyLogin");
const Tracking_1 = require("../../lib/constants/Tracking");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const ApptInfo_1 = __importDefault(require("../ApptInfo"));
const ApptSummary_1 = __importDefault(require("../ApptSummary"));
const ApptTime_1 = __importDefault(require("../ApptTime"));
const Header_1 = __importDefault(require("../Header"));
const Loading_1 = require("../Loading");
const OSWApptInfo_1 = __importDefault(require("../OSWApptInfo"));
const PatientInfo_1 = __importDefault(require("../PatientInfo"));
const styles_1 = require("./styles");
const FullscreenLoader_1 = require("../Util/FullscreenLoader");
const Sidebar_1 = __importDefault(require("../Sidebar"));
const configUtils_1 = require("../../lib/configUtils");
const utils_directBook_1 = require("./utils.directBook");
const config_1 = require("../../lib/constants/config");
/**
 *  Based on the current top level state we'll render a certain section in the app
 */
const renderersByState = [
    [
        States_1.loadingProvider,
        ({ service, track }) => react_1.default.createElement(Loading_1.LoadingProvider, { service: service, track: track })
    ],
    [
        States_1.apptInfo,
        ({ service, config, track, apptPurposeFilterProps }) => (react_1.default.createElement(ApptInfo_1.default, { track: track, service: service, config: config, apptPurposeFilterProps: apptPurposeFilterProps }))
    ],
    [
        States_1.apptTime,
        ({ service, config, darkshipFeatureFlags, mapApiKey, track, apptDensity, offsetTop, showAltProvidersOnStep2, onScroll, awsMapConfig }) => (react_1.default.createElement(ApptTime_1.default, { track: track, mapApiKey: mapApiKey, service: service, config: config, darkshipFeatureFlags: darkshipFeatureFlags, apptDensity: apptDensity, showAltProvidersOnStep2: showAltProvidersOnStep2, offsetTop: offsetTop, onScroll: onScroll, awsMapConfig: awsMapConfig }))
    ],
    [
        States_1.patientInfo,
        ({ service, config, thirdPartyLoginProps, track }) => (react_1.default.createElement(PatientInfo_1.default, { track: track, config: config, service: service, thirdPartyLoginProps: thirdPartyLoginProps }))
    ],
    [
        States_1.apptSummary,
        ({ service, mapApiKey, track, config, awsMapConfig }) => (react_1.default.createElement(ApptSummary_1.default, { service: service, mapApiKey: mapApiKey, track: track, config: config, awsMapConfig: awsMapConfig }))
    ],
    [
        States_1.oswApptInfo,
        ({ service, config }) => react_1.default.createElement(OSWApptInfo_1.default, { service: service, config: config })
    ]
];
// animation variants
// direction is used to determine if we slide left->right or right->left
const variants = {
    enter: (direction) => ({
        x: direction === -1 ? '-20%' : '20%',
        opacity: 0
    }),
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction) => ({
        zIndex: 0,
        x: direction === -1 ? '20%' : '-20%',
        opacity: 0
    })
};
/**
 * @param {String} curStep
 * @returns {String}
 */
const getPageViewTracking = (curStep) => {
    const events = {
        [States_1.apptInfo]: Tracking_1.pageEvents.DBOOK_LANDING,
        [States_1.apptTime]: Tracking_1.pageEvents.PROVIDER_SCHEDULE,
        [States_1.patientInfo]: Tracking_1.pageEvents.PATIENT_REGISTRATION,
        [States_1.apptSummary]: Tracking_1.pageEvents.BOOKED_APPOINTMENT,
        [States_1.oswApptInfo]: Tracking_1.pageEvents.EPIC_OSW
    };
    return events[curStep];
};
const propTypes = {
    /* eslint-disable react/forbid-prop-types */
    config: prop_types_1.object.isRequired,
    darkshipFeatureFlags: prop_types_1.object,
    searchMatchEnabled: prop_types_1.bool.isRequired,
    currentState: (0, prop_types_1.instanceOf)(xstate_1.State).isRequired,
    onGoBack: prop_types_1.func.isRequired,
    track: prop_types_1.func.isRequired,
    mapApiKey: prop_types_1.string,
    awsMapConfig: prop_types_1.object,
    thirdPartyLoginProps: (0, prop_types_1.shape)({
        type: (0, prop_types_1.oneOf)(['mychart']).isRequired,
        isLoggedIn: prop_types_1.bool.isRequired,
        login: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        logout: (0, prop_types_1.shape)({
            url: prop_types_1.string,
            callback: prop_types_1.func.isRequired
        }).isRequired,
        errors: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(Object.values(thirdPartyLogin_1.ERROR)))
    }),
    /* optional react-router history object for db-widget to control url and forward/back */
    history: (0, prop_types_1.shape)({
        push: prop_types_1.func,
        replace: prop_types_1.func,
        location: (0, prop_types_1.shape)({
            pathname: prop_types_1.string,
            search: prop_types_1.string
        })
    }),
    apptDensity: (0, prop_types_1.oneOf)(['default', 'dense']),
    /* Properties for the appointment purpose filter controls */
    apptPurposeFilterProps: (0, prop_types_1.shape)({
        /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
        minPurposesForFilter: prop_types_1.number,
        /* Labels for rendering the filter controls */
        labels: (0, prop_types_1.shape)({
            noResultsLabel: prop_types_1.string,
            purposeSearchLabel: prop_types_1.string,
            purposeSearchPlaceholderLabel: prop_types_1.string,
            visitTypeAllLabel: prop_types_1.string,
            visitTypeInPersonLabel: prop_types_1.string,
            visitTypeVirtualLabel: prop_types_1.string
        }),
        /* Function executed when the name filter changes */
        onNameFilterChange: prop_types_1.func,
        /* Function executed when the visit type filter changes */
        onVisitTypeFilterChange: prop_types_1.func,
        /* Function executed when the filters are cleared */
        onClearFilters: prop_types_1.func
    }),
    onScroll: prop_types_1.func,
    /**
     * Suggest that direct book should render alternate providers at various steps
     */
    featureFlags: (0, prop_types_1.shape)({
        // Suggest alternate providers for step 1
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool,
        dbw_suggest_care_teams_for_step_2_below_alt_provider: prop_types_1.bool,
        dbw_suggest_care_teams_for_step_2: prop_types_1.bool
    })
};
const defaultProps = {
    mapApiKey: '',
    history: null,
    onScroll: () => window.scrollTo(0, 0)
};
function DirectBook(_a) {
    var { currentState, onGoBack, track, history, onScroll, config, searchMatchEnabled, featureFlags } = _a, props = __rest(_a, ["currentState", "onGoBack", "track", "history", "onScroll", "config", "searchMatchEnabled", "featureFlags"]);
    const { context } = currentState;
    const { provider, appointmentQuery, selectedAppointment, steps, curStep, stepsConfigurationType, backToSearchPageURL, isOrderBasedSchedulingFlow } = context;
    const extendedTrack = (0, react_1.useCallback)((event, data) => {
        var _a, _b, _c;
        const extendedData = Object.assign({}, data);
        if (provider) {
            extendedData.provider_id = provider.id;
            extendedData.provider_name =
                (_a = provider.name.full) !== null && _a !== void 0 ? _a : provider.name.full_name;
            extendedData.provider_specialties =
                (_c = (_b = provider === null || provider === void 0 ? void 0 : provider.specialties) === null || _b === void 0 ? void 0 : _b.map((s) => s.name)) !== null && _c !== void 0 ? _c : [];
        }
        track(event, extendedData);
    }, [provider, track]);
    const { ref: headerRef, height: headerHeight } = (0, useThrottledResizeObserver_1.default)({});
    const [bodyIsAnimating, setBodyIsAnimating] = (0, react_1.useState)(false);
    // direction handles the animation direction between steps
    const direction = (0, react_1.useRef)(1);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    // throttle animating state to prevent animation states from infinitely flipping
    const setAnimating = (0, lodash_throttle_1.default)((animating) => {
        setBodyIsAnimating(animating);
    }, 350);
    const showSidebar = aboveMd &&
        !currentState.matches(States_1.apptSummary) &&
        !currentState.matches(States_1.loadingProvider) &&
        !currentState.matches(States_1.initializing) &&
        !currentState.matches(States_1.routing);
    const showAltProvidersOnStep2 = (0, utils_directBook_1.shouldShowAlternativeProviders)({
        currentState,
        config,
        featureFlags
    });
    const stepsConfiguration = steps_1.default[stepsConfigurationType];
    const handleGoBack = (stepStateKey) => {
        if (!stepsConfiguration) {
            return null;
        }
        const curStepIndex = stepsConfiguration.findIndex(({ stateKey }) => stateKey === curStep);
        const nextStepIndex = stepsConfiguration.findIndex(({ stateKey }) => stateKey === stepStateKey);
        direction.current =
            curStepIndex === -1 || curStepIndex > nextStepIndex ? -1 : 1;
        if (!currentState.matches(stepStateKey)) {
            onGoBack(stepStateKey);
        }
    };
    (0, history_routing_1.useHistoryRouting)({
        currentState,
        history,
        handleGoBack,
        stepsConfiguration
    });
    const isApptSummary = currentState.matches(States_1.apptSummary);
    // account for when a user scrolls to the bottom of the
    // appointment list, selects an apointment and goes to the next step
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let patient_relationship;
        if ((_b = (_a = currentState === null || currentState === void 0 ? void 0 : currentState.context) === null || _a === void 0 ? void 0 : _a.selectedAppointment) === null || _b === void 0 ? void 0 : _b.purpose) {
            ({ patient_relationship } =
                (_d = (_c = currentState === null || currentState === void 0 ? void 0 : currentState.context) === null || _c === void 0 ? void 0 : _c.selectedAppointment) === null || _d === void 0 ? void 0 : _d.purpose);
        }
        let provider_specialties = null;
        if ((_f = (_e = currentState === null || currentState === void 0 ? void 0 : currentState.context) === null || _e === void 0 ? void 0 : _e.provider) === null || _f === void 0 ? void 0 : _f.specialties) {
            provider_specialties = (_j = (_h = (_g = currentState === null || currentState === void 0 ? void 0 : currentState.context) === null || _g === void 0 ? void 0 : _g.provider) === null || _h === void 0 ? void 0 : _h.specialties) === null || _j === void 0 ? void 0 : _j.map((s) => s.name);
        }
        const pageViewTracking = getPageViewTracking(curStep);
        if (pageViewTracking) {
            let eventData = {};
            if (patient_relationship) {
                eventData.patient_relationship = patient_relationship;
            }
            if (provider_specialties) {
                eventData.provider_specialties = provider_specialties;
            }
            if (Object.keys(eventData).length === 0) {
                eventData = null;
            }
            if (eventData) {
                extendedTrack(pageViewTracking, eventData);
            }
            else {
                extendedTrack(pageViewTracking);
            }
        }
        if (isApptSummary) {
            if (patient_relationship === Filters_1.NEW_PATIENT) {
                extendedTrack(Tracking_1.userEvents.APPT_BOOKED_NEW_RELATIONSHIP);
            }
            if (patient_relationship === Filters_1.ESTABLISHED_PATIENT) {
                extendedTrack(Tracking_1.userEvents.APPT_BOOKED_ESTABLISHED_RELATIONSHIP);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curStep, isApptSummary, extendedTrack]); // ignore es-lint for this array, do not add currentState here or it breaks stuff :(
    const [, render] = renderersByState.find(([state]) => currentState.matches(state)) || [];
    (0, react_1.useLayoutEffect)(() => {
        if (!bodyIsAnimating && onScroll) {
            onScroll();
        }
    }, [curStep, onScroll, bodyIsAnimating]);
    (0, react_1.useEffect)(() => {
        if (window && 'scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        return () => {
            if (window && 'scrollRestoration' in (window === null || window === void 0 ? void 0 : window.history)) {
                window.history.scrollRestoration = 'auto';
            }
        };
    }, []);
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "DirectBook", className: "DirectBook", id: config_1.DIRECT_BOOK_CONTAINER_ID },
        currentState.matches(States_1.patientInfo) && (react_1.default.createElement(FullscreenLoader_1.FullScreenLoader, { service: steps[curStep], isRenderingInDrawer: (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags) })),
        react_1.default.createElement(Header_1.default, { ref: headerRef, onGoBack: handleGoBack, config: config, featureFlags: featureFlags, searchMatchEnabled: searchMatchEnabled, backToSearchPageURL: backToSearchPageURL, aboveMd: aboveMd, currentState: currentState, stepsConfiguration: stepsConfiguration, track: extendedTrack, isOrderBasedSchedulingFlow: isOrderBasedSchedulingFlow }),
        react_1.default.createElement(styles_1.BodyContainer, { isApptSummary: isApptSummary },
            react_1.default.createElement(framer_motion_1.AnimatePresence, { custom: direction.current, exitBeforeEnter: true, initial: false },
                react_1.default.createElement(styles_1.Body, { key: curStep, positionTransition: true, custom: direction.current, variants: variants, initial: "enter", animate: "center", exit: "exit", onAnimationComplete: () => {
                        setAnimating(false);
                        if (direction.current === -1) {
                            direction.current = 1;
                        }
                    }, onAnimationStart: () => {
                        setAnimating(true);
                    } },
                    render && (react_1.default.createElement(styles_1.Content, { showSidebar: showSidebar }, render(Object.assign(Object.assign({}, props), { bodyIsAnimating,
                        config,
                        onScroll, track: extendedTrack, showAltProvidersOnStep2, service: steps[curStep], ctx: context, offsetTop: headerHeight - 1 })))),
                    showSidebar && (react_1.default.createElement(Sidebar_1.default, { appointmentQuery: appointmentQuery, config: config, showAltProvidersOnStep2: showAltProvidersOnStep2, provider: provider, selectedAppointment: selectedAppointment, service: steps[curStep], track: extendedTrack })))))));
}
exports.default = DirectBook;
DirectBook.propTypes = propTypes;
DirectBook.defaultProps = defaultProps;
//# sourceMappingURL=DirectBook.js.map